module.exports = __webpack_public_path__ + "img/under.0b664c72.png";